export default __webpack_public_path__ + "static/media/choir.cfabf9c5.jpg";